import React from 'react';
import { range } from 'lodash';
import { observer } from 'src/utils/mobx-react';
import { ViewRaceCardLoader } from 'src/domains/layouts/shared/loaders';
import { RaceBoxSelectionLoader } from 'src/domains/sportsbook/webview/components/raceBoxSelection/RaceBoxSelectionLoader';
import { numberOfItemsInRaceBox } from 'src/domains/sportsbook/webview/components/nextRaces/racesSlider/NextRacesSliderList';
import {
    RaceSliderHeaderLoader,
    RaceSliderItemLoaderWrapper,
    RaceSliderListItem,
} from 'src/domains/sportsbook/webview/components/racesSlider/loader/RaceSliderItemLoader.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

export const RaceSliderItemLoader = observer('RaceSliderItemLoader', (): JSX.Element => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const { raceCardVariant } = configState.componentVariants;
    return (
        <RaceSliderItemLoaderWrapper>
            <RaceSliderHeaderLoader variant={raceCardVariant} />

            <ul key='race-box-selections'>
                {range(0, numberOfItemsInRaceBox).map((x) => (
                    <RaceSliderListItem
                        key={x}
                        variant={raceCardVariant}
                    >
                        <RaceBoxSelectionLoader />
                    </RaceSliderListItem>
                ))}
                <RaceSliderListItem variant={raceCardVariant}>
                    <ViewRaceCardLoader variant={raceCardVariant} />
                </RaceSliderListItem>
            </ul>
        </RaceSliderItemLoaderWrapper>
    );
});
